import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { useMastersContext } from "../../../../contexts/masters.context";
import ExceptionCategoryService from "../../../../services/ExceptionCategoryService";
import CrudTable from "../../shared/table/CrudTable";
import { TABLE_COLUMNS } from "./models/ExceptionCategoryTableColumns";

function ExceptionCategoryTable() {
  const {
    push,
    location: { pathname },
  } = useHistory();

  const { exceptionCategoryState } = useMastersContext();
  
  useEffect(() => {
    exceptionCategoryState.fetch();
  }, []);

  const columns = useMemo(() => TABLE_COLUMNS, [TABLE_COLUMNS]);
  const data = useMemo(() => exceptionCategoryState.data || [], [
    exceptionCategoryState.data,
  ]);

  const removeHandler = async (id) => {
    if (window.confirm("Are you sure ?") === true) {
      const result = await ExceptionCategoryService.remove(id);
      if (result.success === true) {
        exceptionCategoryState.fetch();
      }
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col"></div>
        <div className="col">
          <h4>Exception Category</h4>
        </div>
        <div className="col d-flex justify-content-end">
          <button
            className="btn btn-sm btn-success"
            onClick={() => push(`${pathname}/add`)}
          >
            Add New
          </button>
        </div>
      </div>
      <hr />
      <CrudTable
        loading={exceptionCategoryState.loading}
        data={data}
        columns={columns}
        idField="ecrcT_ID"
        onEdit={(id) => push(`${pathname}/edit/${id}`)}
        onRemove={removeHandler}
      />
    </div>
  );
}

export default ExceptionCategoryTable;
